import { EMAIL_REGEX } from '@aytm/app/lib/regex'
import { LoginFormErrors, LoginFormState } from '../types'

export function validateLoginForm(form: LoginFormState, options: { skipPassword?: boolean } = {}): LoginFormErrors {
  const errors: LoginFormErrors = { email: null, password: null, base: null }

  if (!form.email.trim()) {
    errors.email = 'This field is required'
  } else if (!EMAIL_REGEX.test(form.email)) {
    errors.email = 'Please enter a valid email address'
  }

  // On an SSO match the password field is hidden and never submitted (the server
  // short-circuits to the IdP), so the password requirement must be skipped — otherwise
  // the SSO submit is blocked before it can reach the redirect (GAP-002).
  // The password is NOT trimmed (§6.1): only a truly empty value is "required", so a
  // whitespace-only password still reaches the server (GAP-030).
  if (!options.skipPassword && form.password.length === 0) {
    errors.password = 'This field is required'
  }

  return errors
}

export function hasErrors(errors: LoginFormErrors): boolean {
  return Object.values(errors).some(v => v !== null)
}
